import React from 'react';

import Lightbox from 'components/Lightbox';

// eslint-disable-next-line no-unused-vars
export const transformHtmlToLightbox = (reactNode, domNode, index) => {
  const { props, type } = reactNode;

  if (type === 'img') {
    const _props = { ...props };
    const { src } = props;
    if (src) {
      const parts = src.split('/');
      const filename = parts[parts.length - 1];
      _props.filename = filename;
    }
    return <Lightbox {..._props} />;
  };

  return reactNode;
};
